import styled, { css, DefaultTheme } from 'styled-components';

import { TStyledLinkProperties, TLinkTypes } from './link.types';

export const StyledWrapper = styled.span`
    display: inline-block;
`;

function setTextDecoration(
    linkType: TLinkTypes,
    hasIcon: boolean,
    isHoverState = false
): string {
    if (hasIcon && linkType === 'default') {
        return isHoverState ? 'underline' : 'none';
    }

    if (isHoverState) {
        return linkType === 'default' ? 'none' : 'underline';
    }
    return linkType === 'list' ? 'none' : 'underline';
}

function setColor(
    theme: DefaultTheme,
    linkType: TLinkTypes,
    inverted: boolean
): string {
    if (inverted) {
        return theme.color.white;
    }

    if (linkType === 'list') {
        return theme.color.black;
    }
    return theme.color.purple;
}

export const StyledLink = styled.a<TStyledLinkProperties>`
    display: flex;
    align-items: center;
    padding: 0;
    color: ${({ theme, linkType, inverted }) =>
        setColor(theme, linkType, inverted)};
    font-size: inherit;
    text-decoration: ${({ linkType, hasIcon }) =>
        setTextDecoration(linkType, hasIcon)};
    background: transparent;
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.default};
    outline: none;
    cursor: pointer;

    ${({ hasIcon }) =>
        hasIcon &&
        css`
            & svg {
                margin-right: 0.4rem;
            }
        `};

    &:hover {
        text-decoration: ${({ linkType, hasIcon }) =>
            setTextDecoration(linkType, hasIcon, true)};
    }

    &:focus {
        box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.color.purpleTint20};
    }
`;
